import routes from "web/routes/constants"
import ObjectListController from "./object_list_controller"

export default class DealAssetsObjectListController extends ObjectListController {
  connect() {
    super.connect()
  }

  onItemClick(dealAsset) {
    window.Turbo.visit(
      routes.deal_asset(
        this.viewGroupValue.slug,
        null,
        dealAsset.deal_id,
        dealAsset.id
      )
    )
  }
}
